module.exports = __webpack_public_path__ + "static/media/knp.72de4bab.svg";